/** @jsxImportSource theme-ui */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { List } from 'semantic-ui-react';

import { Geoname } from 'utils/constants';

import { FlexGroup } from 'components/_common/FlexGroup';
import { Typography } from 'components/_common/Typography';

import { openPanel } from 'diseaseActivityPanels/diseaseActivityPanels.saga';
import diseaseActivityPanelsSelectors from 'diseaseActivityPanels/diseaseActivityPanels.selectors';

import { locationCardStyle } from './locations.styles';

const title = 'Global';
const subtitle = 'Location-agnostic view';

const GlobalLocationCard: React.FC = () => {
  const dispatch = useDispatch();
  const isGlobalSelected = useSelector(diseaseActivityPanelsSelectors.isGlobalSelected);
  return (
    <List.Item
      data-testid="global-location-card"
      active={isGlobalSelected}
      sx={locationCardStyle}
      onClick={e => dispatch(openPanel({ panel: 'Diseases', geonameId: Geoname.GLOBAL_VIEW }))}
    >
      <FlexGroup alignItems="center">
        <Typography variant="subtitle2" color="stone90">
          {title}
        </Typography>
        <Typography variant="body2" color="deepSea50">
          {subtitle}
        </Typography>
      </FlexGroup>
    </List.Item>
  );
};

export default GlobalLocationCard;
